import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Base = styled.div`
  border-radius: 6px;
  box-shadow: 0 0 8px -3px black;
  cursor: pointer;
  height: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  z-index: 80;

  &::after {
    border-left: 2px solid black;
    border-top: 2px solid black;
    content: '';
    height: 8px;
    position: absolute;
    top: calc(50% - 6px);
    width: 8px;
  }
`;

const Left = Base.extend`
  left: -30px;

  &::after {
    right: 2px;
    transform: rotate(-45deg);
  }
`;

const Right = Base.extend`
  right: -30px;

  &::after {
    left: 2px;
    transform: rotate(135deg);
  }
`;

const Arrow = ({ onClick, left }) => (left ? <Left onClick={onClick} /> : <Right onClick={onClick} />);

Arrow.defaultProps = {
  left: false,
  onClick: undefined,
};

Arrow.propTypes = {
  left: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/ProductRecommendation/Arrow.js